import styled from "@emotion/styled";
import Container from "@mui/system/Container";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import DialogContent from "@mui/material/DialogContent";

const inputWidth = 300;
const inputMargin = 10;
const ContainerPrimary = styled(Container)(({ theme }) => ({
    backgroundColor: theme.palette.primary.main,
}));

const TextPrimary = styled(Typography)(({ theme }) => ({
    color: theme.palette.primary.contrastText
}));

const TextSecondary = styled(Typography)(({ theme }) => ({
    color: theme.palette.secondary.text
}));

const TextError = styled(Typography)(({ theme }) => ({
    color: theme.palette.error.text
}));

const LinkPrimary = styled(Link)(({ theme }) => ({
    color: theme.palette.primary.contrastText,
    ':hover': {
        color: theme.palette.primary.contrastText,
        cursor: 'pointer'
    }
}));

const SelectPrimary = styled(Select)(({ theme }) => ({
    width: inputWidth
}));

const FormWithMargin = styled(FormControl)(({ theme }) => ({
    margin: inputMargin
}));

const LightContainerWithMargin = styled(Container)(({ theme }) => ({
    backgroundColor: theme.palette.primary.light,
    margin: inputMargin,
    color: theme.palette.primary.contrastText,
    borderRadius: 5
}));

const DarkContainerWithMargin = styled(Container)(({ theme }) => ({
    backgroundColor: theme.palette.primary.dark,
    margin: inputMargin,
    color: theme.palette.primary.contrastText,
    borderRadius: 5
}));

const ErrorContainerWithMargin = styled(Container)(({ theme }) => ({
    backgroundColor: theme.palette.error.main,
    margin: inputMargin,
    color: theme.palette.primary.contrastText,
    borderRadius: 5
}));

const CenteredDialogContent = styled(DialogContent)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    p: 10
}));
export { 
    ContainerPrimary, 
    TextPrimary, 
    TextSecondary,
    TextError,
    LinkPrimary,
    SelectPrimary,
    FormWithMargin,
    LightContainerWithMargin,
    DarkContainerWithMargin,
    ErrorContainerWithMargin,
    CenteredDialogContent
};